import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import GamifyingTheFutureOfSustainability from "./sections/GamifyingTheFutureOfSustainability";
import BlogUpdatesFeed from "./sections/BlogUpdatesFeed";
import FeaturedMortgageGuide from "./sections/FeaturedMortgageGuide";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
import UniversitySummaryCard from "./sections/UniversitySummaryCard";
import EnrollmentTimeline from "./sections/EnrollmentTimeline";
import CollegesDepartments from "./sections/CollegesDepartments";
export default function HomePage() {
  return <div>
      <Header />
      <GamifyingTheFutureOfSustainability />
      <UniversitySummaryCard />
      <BlogUpdatesFeed />
      <CollegesDepartments />
      <EnrollmentTimeline />
      <FeaturedMortgageGuide />
      <Faq />
      <Footer />
    </div>;
}